export default "__VITE_ASSET__DhCBLHcK__"